import { Dictionary } from '@/types/field'
import { createSelector } from 'reselect'

// Select entities from state
const getUiState = (state: Dictionary) => state.ui

// = ====================================
//  MEMOIZED SELECTORS
// -------------------------------------

export const getUiInfo = createSelector(getUiState, (data: Dictionary) => {
    return {
        pageTitle: data.pageTitle,
        mainTitle: data.mainTitle,
        mainSlug: data.mainSlug
    }
})
